import { VStack } from "@chakra-ui/react"
import React from "react"
import { CreateWorkShiftForm } from "../../forms"

export const CreateWorkShift: React.FC = () => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<CreateWorkShiftForm />
		</VStack>
	)
}
